<template>
  <div>
    <div id="accordionMeasurement">
      <div class="card-pei">
        <div
          v-if="!fromManagement"
          class="cursor--pointer"
          aria-expanded="true"
          aria-controls="collapseOne"
          @click="toggleExpand"
        >
          <div class="accordion-header-container">
            <div class="collapse-title d-flex">
              <span class="bg-light-gray my-3 radius-20">
                <span class="bg-white p-1 radius-100">
                  <i
                    class="fal fa-lg"
                    :class="{
                      'fa-chevron-circle-right orange': !getIsExpanded,
                      'fa-chevron-circle-down text-success': getIsExpanded
                    }"
                  />
                </span>
                Proceso realizado previo a Solicitud de Asistencia Técnica de
                Ubicación
              </span>
            </div>
          </div>
        </div>
        <div
          id="collapseOne"
          :key="'options'"
          :class="{
            'collapse mt-2': !getIsExpanded,
            'collapse show mt-2': getIsExpanded
          }"
          aria-labelledby="headingOne"
        >
          <div v-if="!fromManagement" class="d-flex flex-column">
            <div class="question-element">
              <div class="item-pane">
                <div class="question-box">
                  <div class="box-number">
                    <div>
                      1
                      <sup class="question-number-sup" />
                    </div>
                  </div>
                </div>
                <div class="question-line col py-3">
                  <p :id="`pName-1`" class="mb-0 p-2 pl-4">
                    ¿Se realizó una prediscusión de caso con un Facilitador
                    Docente?
                  </p>
                </div>
                <div
                  class="align-items-start d-flex p-0 custom-radio-container"
                >
                  <ValidationProvider>
                    <RadioButton
                      :name="'rbQuestion-1'"
                      :question-lists="getOptions"
                      :change-event="onChange"
                      class="radio-button-container"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showMsgErrorSection1" class="div-error">
            <p class="px-2 mb-0">
              Favor de proceder a realizar el proceso de prediscusión de caso
              con el facilitador correspondiente. Una vez lo realice, podrá
              ingresar la evidencia y comenzar con el proceso de Solicitud de
              Asistencia Técnica de Ubicación del Estudiante.
            </p>
          </div>
          <div
            v-if="
              municipalitiesList.length > 0 &&
                (model.facilitatorDiscussionOccurred || fromManagement)
            "
            :key="'preDiscussion'"
            class="p-3 bg"
          >
            <div class="row">
              <div class="col-md-5 col-sm-12 mb-3">
                <ValidationProvider
                  name="Municipio de Residencia"
                  v-slot="{ errors }"
                  rules="emptyObject|required"
                >
                  <label class="input-label">Municipio de Residencia:</label>
                  <CustomDropDown
                    v-if="!isReadOnly"
                    v-model="model.municipality"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="municipalitiesList"
                    :error="errors[0]"
                  />

                  <div v-if="isReadOnly" class="regular">
                    {{ getMunicipalityName() }}
                  </div>
                  <Error
                    v-if="errors[0]"
                    variant="no-border"
                    message="Favor seleccionar municipio de residencia."
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-5 col-sm-12">
                <ValidationProvider
                    name="Nombre del Facilitador Docente"
                    v-slot="{ errors }"
                    rules="required"
                  >
                  <label class="input-label">
                    Nombre del Facilitador Docente:
                  </label>
                  <CustomInput
                    v-if="!isReadOnly"
                    v-model="model.facilitatorName"
                    type="text"
                    :error="errors[0]"
                  />
                  <div v-if="isReadOnly" class="regular">
                    {{ model.facilitatorName }}
                  </div>
                  <Error
                    v-if="errors[0]"
                    variant="no-border"
                    message="Favor escriba nombre del facilitador docente."
                  />
                </ValidationProvider>
              </div>
              <template v-if="!fromManagement">
                <div class="col-12 mt-2">
                  <label class="input-label">Descripción:</label>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="description"
                    :rules="!isReadOnly ? 'required' : ''"
                  >
                    <CustomTextArea
                      v-show="true"
                      :id="'description'"
                      v-model="model.facilitatorDiscussionDescription"
                      style="width:100%"
                      :maxlength="3000"
                      :classes="['eq-field', 'text-left']"
                      :rows="5"
                      :error="errors[0]"
                      :custom-error-msg="'Favor escriba una descripción.'"
                      :disabled="isReadOnly"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-12 col-md-6 mt-2">
                  <label class="input-label">Documento:</label>
                  <p class="document-name">
                    Evidencia de prediscusión de caso con Facilitador Docente
                    (SAEE-07)
                  </p>
                </div>
                <div class="col-12 col-md-6 mt-2">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Archivo"
                    rules="required"
                  >
                    <CustomFileInput
                      ref="attachedDocument"
                      v-model="model.facilitatorDiscussionFile"
                      label="Archivo:"
                      :accept="allowedFiles"
                      required
                      display-style="normal"
                      label-position="left"
                      :error="errors[0]"
                      :attachment-id="getDocument.documentId"
                      :name="getDocument.filename"
                      :custom-error-msg="
                        errors[0] ? 'Favor anejar un documento.' : ''
                      "
                      :disabled="isReadOnly || !!getDocument.documentId"
                    />
                  </ValidationProvider>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import CustomTextArea from "@/components/common/CustomTextArea";
import RadioButton from "@/components/common/CustomRadioButton";
import CustomFileInput from "@/components/common/CustomFileInput";
import { CustomDropDown, Error, CustomInput } from "@/components/common";
import { extend } from "vee-validate";

extend("emptyObject", value => {
  return Object.keys(value).length != 0;
});
export default {
  name: "UbicationTechAssistanceSection1",
  data() {
    return {
      allowedFiles: ".pdf"
    };
  },
  components: {
    ValidationProvider,
    RadioButton,
    CustomTextArea,
    CustomFileInput,
    CustomDropDown,
    CustomInput,
    Error
  },
  methods: {
    onChange(item) {
      this.$emit("resetMsgErrorSection1");
      this.model.facilitatorDiscussionOccurred = item.id;
    },
    toggleExpand() {
      this.$emit("expanded", !this.isExpanded);
    },
    getMunicipalityName() {
      if (this.model.municipality.id) {
        const municipality = this.municipalitiesList.filter(
          x => x.id === this.model.municipality.id
        )[0];

        return municipality ? municipality.name : "";
      }
    }
  },
  computed: {
    getIsExpanded() {
      return this.isExpanded;
    },
    getDocument() {
      if (!this.model.documents) {
        return { documentId: null, filename: null };
      }
      return this.model.documents.find(x => x.document.documentTypeId == 175);
    },
    getOptions() {
      return {
        invalid: false,
        options: [
          {
            id: true,
            label: "Si",
            check: this.model.facilitatorDiscussionOccurred === true,
            disabled: this.isReadOnly
          },
          {
            id: false,
            label: "No",
            check: this.model.facilitatorDiscussionOccurred === false,
            disabled: this.isReadOnly
          }
        ]
      };
    }
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: true
    },
    showMsgErrorSection1: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: () => {}
    },
    municipalitiesList: {
      type: Array,
      default: () => []
    },
    fromManagement: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.document-name {
  font: normal normal normal 16px/20px Lato;
  letter-spacing: 0px;
  color: #11291b;
  opacity: 1;
}
.radius-20 {
  border-radius: 20px;
}
.radius-100 {
  border-radius: 100%;
}
.bg {
  background: #f7f7f7;
}
.div-error {
  background: #feeaea;
  padding: 20px;
}
.div-error p {
  color: #c9545e;
  font: normal normal normal 16px/19px Lato;
  border-radius: 0px 0px 5px 5px;
}
.question {
  /* box-shadow: -3px 1px 3px #00000029; */
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  /* box-shadow: -3px 1px 3px #00000029; */
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.orange {
  color: #ff7058;
}
.box-number {
  font: Bold 32px/19px Lato;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
  align-items: unset !important;
}
.question-line p >>> p {
  margin-bottom: 0px !important;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
}
.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.row-checkbox {
  width: 20px;
  height: 20px;
  width: 10%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
}

.row-text {
  width: 90%;
}

.row-odd {
  background-color: #fafbfa;
}

.row-even {
  background-color: #ffffff;
}

.text-fix {
  font-weight: 400;
}
.relative-top-10 {
  position: relative;
  top: 0.8em;
}
.card-pei >>> .input-label {
  color: #727272;
  font-size: 14px;
}
</style>
